import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App as AntApp } from 'antd';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { getAuthMeQueryKey } from '@/api/generated/endpoints/auth/auth';
import { configureDesktop } from '@/desktop';
import { registerServiceWorker } from '@/pwa';
import { ApiProblem, setUnauthorizedHandler } from '@/api/http';
import '@/global.css';
import '@/i18n';
import { LocalizedAntd } from '@/i18n/LocalizedAntd';
import { router } from '@/router';

// В десктопном клиенте запросы идут на сервер из настроек через плагин программы.
configureDesktop();
registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Повтор имеет смысл только для сетевых сбоев и 5xx, не для 4xx.
      retry: (count, error) =>
        count < 1 && (!(error instanceof ApiProblem) || error.status === 0 || error.status >= 500),
    },
  },
});

// 401 посреди работы (сессия истекла или отозвана): забыть пользователя — RequireAuth
// перечитает /auth/me, получит 401 и отправит на вход с возвратом на текущую страницу.
setUnauthorizedHandler(() => {
  void queryClient.resetQueries({ queryKey: getAuthMeQueryKey() });
});

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <LocalizedAntd>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </AntApp>
    </LocalizedAntd>
  </StrictMode>,
);
